import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {get} from '../../../api';
import Label from '../../auth/components/Label';
import Button from '../../auth/components/Button';
import {MdExpandMore} from '../../../icons/Icons';
import uniqby from 'lodash.uniqby';
import StateBasedPagination from '../../cmp/StateBasedPagination';
import useDebounce from '../../cmp/hooks/useDebounce';
import Input from '../../cmp/form/Input';
import LoadingSkeleton from '../../cmp/LoadingSkeleton';


function useEmbeddedInPage(){
    return useMemo(()=>{
        return document.location.href.includes('pages')
    },[])
}
function ConnectedCustomersWidget() {
    const isEmbedded = useEmbeddedInPage()
    const [limit, setLimit] = useState(isEmbedded ? 30 : 5);
    const [offset, setOffset] = useState(0)
    const [customers, setCustomers] = useState([])
    const [count, setCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const loadData = useCallback((_search) => {
        setLoading(true)
        get('/connected_customers',{
            limit,
            offset,
            search:_search,

        })
        .then((data) => {
            setLoading(false)
            if(isEmbedded){
                setCustomers(data.customers)
            }else {
                setCustomers(
                    (e) => uniqby([...e, ...data.customers], (e) => e.email))
            }
            setCount(data.total_results)
        }).catch(() => {
            console.log()
        })
    },[offset,isEmbedded, limit])

    const [search, setSearch ] = useState('')
    const _search = useDebounce(search, 500)

    useEffect(()=>{
        loadData(search)
    },[offset, limit])

    useEffect(()=>{
        setOffset(0);
        loadData(search)
    },[_search])

    if(isEmbedded){
       return <><div className={"card"}>
            <div className="card-body">
                <Label><FormattedMessage id={"Customers"}/></Label>
                {
                    loading ? <LoadingSkeleton height={63.5}/> :
                        <div className={"display-4"}>{count}</div>
                }
            </div>
       </div>
           <div className="mt-3">
               <Input placeholder={"Search..."} type={"search"} onChange={setSearch} value={search} />
           </div>

           <div className="row mt-3">
               {
                   loading ? <>
                       {
                            [...new Array(30)].map((i, index)=>{
                                return   <div key={String(index)} className="col-md-4 mb-4">
                                    <LoadingSkeleton height={68} />
                                </div>
                            })
                       }

               </> : <>
               {
                   customers.map(({name, email}) => {
                       return   <div key={email} className="col-md-4 mb-4">
                           <CustomerItem key={email} name={name}
                                         email={email}/>
                           </div>
                       })
                   }</>
               }
           </div>
           <div className="d-flex align-items-center justify-content-end">
               <StateBasedPagination
                   limit={limit}
                   setLimit={setLimit}
                   count={count} page={Math.round(offset/limit)} goToPage={(page)=>setOffset(page * limit)} />
           </div>
        </>
    }else {

        return (
            <div className={"card"}>
                <div className="card-body">
                    <Label><FormattedMessage id={"Customers"}/></Label>
                    <div className={"display-4"}>{count}</div>
                </div>
                <ul className="list-group list-group-flush">
                    {
                        customers.map(({name, email}) => {
                            return <CustomerItem key={email} name={name}
                                                 email={email}/>
                        })
                    }
                </ul>
                {
                    count > limit + offset && <div className="text-center">
                        <Button loading={loading} className={"btn btn-link"}
                                onClick={() => setOffset((x) => x + limit)}>
                            <MdExpandMore/>
                        </Button>
                    </div>
                }
            </div>
        );
    }
}

function CustomerItem({name, email, created_date}) {
    return <li className={"list-group-item"}>
        <div>{name}</div>
        <small><a title={"Email customer"} href={"mailto:"+email} target={"_blank"}>{email}</a></small>
    </li>
}

export default ConnectedCustomersWidget;
